import { Component, input } from '@angular/core';
import { Router } from '@angular/router';
import { ButtonModule } from '@components/button';
import {ButtonCtaComponent} from '@components/button-cta/button-cta.component';
import { EventLoggerService } from '@services/event-logger-service';

@Component({
  selector: 'shop-navigate-banner',
  templateUrl: './shop-navigate-banner.component.html',
  standalone: true,
  imports: [ButtonModule, ButtonCtaComponent],
})
export class ShopNavigateBannerComponent {

  isAcqShop = input<boolean>(false);

  /**
   * Scroll to the first rendered section in Shop Revamp.
   * Shop page will interpret this query param and scroll accordingly.
   */
  private static readonly SHOP_FIRST_SECTION_PARAM = 'first_revamp_shop_section';

  constructor(
    private readonly router: Router,
    private readonly eventLogger: EventLoggerService,
  ) {}

  navigateToShopSection(): void {
    this.eventLogger.cleverTapEvent('click', JSON.stringify({ name: this.isAcqShop() ? 'acquisition_shop_banner' : 'shop_banner' }));
    if (this.isAcqShop()) {
      this.router.navigateByUrl(`/unpaid-user-shop`);
    } else {
      this.router.navigateByUrl(`/shop?section=${ShopNavigateBannerComponent.SHOP_FIRST_SECTION_PARAM}`);
    }
  }
}
